import React, { useEffect } from 'react';
import { Button, ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../../components/Rodal/Rodal';
import { LevelOfService } from '../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import { useDispatch } from 'react-redux';
import { useStateSelector } from '../../../../store/selectors';
import { LoadMarketplacePricing } from '../../../../slices/marketplace/pricing/load-marketplace-pricing.thunk';
import createNotification from '../../../../utils/createNotification';
interface TerminateEngagementPopupProps {
    isVisible: boolean;
    setIsVisible(value: boolean): void;
    levelOfService: LevelOfService;
    engagementId: number;
    fetchData(): void;
}

export const TerminateEngagementPopup = (
    props: TerminateEngagementPopupProps
) => {
    const dispatch = useDispatch() as any;
    const axios = useStateSelector((state) => state.core.axios);

    useEffect(() => {
        dispatch(LoadMarketplacePricing(props.engagementId));
    }, []);

    const terminateEngagement = () => {
        axios
            .post(
                `/api/Marketplace/Engagements/${props.engagementId}/Terminate`
            )
            .then((response) => {
                if (response?.request?.status !== 200) {
                    createNotification(
                        'An error occured during termination',
                        'error'
                    );
                } else {
                    props.fetchData();
                }
            })
            .catch(() => {
                createNotification(
                    'An error occured during termination',
                    'error'
                );
            })
            .finally(() => {
                props.setIsVisible(false);
            });
    };

    return (
        <>
            <Rodal
                visible={props.isVisible}
                onClose={() => props.setIsVisible(false)}
                animation="slideUp"
                className="terminate-engagement-popup"
                showMask={true}
                width={600}
                showCloseButton={true}>
                <ModalHeader>Terminate Engagement</ModalHeader>
                <ModalBody>
                    <div>
                        <div className="mb-2">
                            Terminating the engagement will end this engagement
                            and all accrued credits towards the transaction fee
                            will be forfeited.
                        </div>

                        <div className="mb-2">
                            If a transaction, as defined in the engagement
                            agreement, for your practice is executed during the
                            tail period commencing on the date you terminate
                            this engagement, you remain legally obligated to pay
                            the transaction fee on this engagement associated
                            with that transaction to VetValue .
                        </div>
                        <div className="mb-2">
                            For any transaction, as defined in the engagement
                            agreement, executed for your practice after the tail
                            period has expired, you will have no further
                            obligation to VetValue.
                        </div>
                        <div className="mb-2">
                            By hitting the terminate button, this engagement is
                            permanently terminated, effective immediately. You
                            are always free to apply for a new engagement in the
                            future.
                        </div>
                        <div className="suspend-buttons-section">
                            <button
                                className="btn btn-outline-secondary"
                                onClick={() => props.setIsVisible(false)}>
                                Continue Engagement
                            </button>
                            <Button
                                color="primary"
                                className="select-documents-btn"
                                onClick={() => {
                                    terminateEngagement();
                                }}>
                                Yes, Terminate Engagement
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            </Rodal>
        </>
    );
};
